export function getEventsHistoryData(state) {
  return state.eventsHistoryData;
}

export function getAgreementsHistoryData(state) {
  return state.agreementsHistoryData;
}
